var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fulfillment-check" }, [
    _c("img", {
      staticStyle: { height: "48px", width: "48px", "margin-bottom": "16px" },
      attrs: { src: require("../../../assets/warning-icon.svg") },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "heading" }, [
      _vm._v("\n    This account requires delayed fulfillment.\n  "),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bypass-section" },
      [
        _c(
          "el-tooltip",
          {
            attrs: {
              content: _vm.userCanBypass()
                ? "Bypass will be logged"
                : "Contact a leader for bypass",
              placement: "top",
            },
          },
          [
            _c(
              "el-checkbox",
              {
                staticClass: "bypass-checkbox",
                attrs: { disabled: !_vm.userCanBypass(), value: _vm.value },
                on: { change: _vm.handleBypassChange },
              },
              [_vm._v("\n        Bypass fulfillment\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "word-break": "break-word" } }, [
      _c("div", [
        _vm._v(
          "\n      The neighbor must return the device to us before the new device will be shipped out.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }